export const enum CyclePhases {
    Menstrual = "Menstrual",
    Follicular = "Follicular",
    Ovulation = "Ovulation",
    Luteal = "Luteal",
}
